import { createRouter, createWebHistory } from 'vue-router'
import PackingList from '@/views/PackingList.vue'
import Home from '@/views/Home.vue'
import Overview from '@/views/Overview.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/overview',
      name: 'overview',
      component: Overview
    },
    {
      path: '/list/:id',
      name: 'packing-list',
      component: PackingList,
      props: true
    }
  ]
})

export default router